import { 
  getAuth, 
  signInWithEmailAndPassword, 
  signOut as firebaseSignOut,
  onAuthStateChanged
} from 'firebase/auth';
import { AdminUser } from '../types/admin';

const auth = getAuth();

// Sign in function with detailed error handling
export const signIn = async (email: string, password: string): Promise<{ user: AdminUser | null; error: string | null }> => {
  try {
    // TODO: [FIRESTORE-INTEGRATION] Replace this with your admin authentication logic
    // Consider implementing custom claims or a separate admin collection to verify admin status
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    
    // Placeholder for admin verification
    /* 
    FIRESTORE-INTEGRATION: 
    1. Verify user has admin role in Firestore
    2. Get additional admin metadata
    3. Set up custom claims if needed
    */
    
    const adminUser: AdminUser = {
      uid: userCredential.user.uid,
      email: userCredential.user.email!,
      role: 'admin',
      lastLogin: new Date(),
    };

    return { user: adminUser, error: null };
  } catch (error: any) {
    return { 
      user: null, 
      error: error.message || 'Failed to sign in' 
    };
  }
};

// Sign out function
export const signOut = async (): Promise<{ error: string | null }> => {
  try {
    await firebaseSignOut(auth);
    return { error: null };
  } catch (error: any) {
    return { error: error.message || 'Failed to sign out' };
  }
};

// Auth state observer
export const subscribeToAuthChanges = (
  callback: (user: AdminUser | null) => void
) => {
  return onAuthStateChanged(auth, (user) => {
    if (user) {
      // TODO: [FIRESTORE-INTEGRATION] Verify admin status in Firestore
      const adminUser: AdminUser = {
        uid: user.uid,
        email: user.email!,
        role: 'admin',
        lastLogin: new Date(),
      };
      callback(adminUser);
    } else {
      callback(null);
    }
  });
};

// Protected route checker
export const isAuthenticated = (): boolean => {
  const user = auth.currentUser;
  // TODO: [FIRESTORE-INTEGRATION] Add additional admin role verification
  return !!user;
};
